import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitLoanCalculator = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const Helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth) 

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormRequestGlobal = useForm(defaultData.defaultFormGlobal)

    const Forms = {
        FormRequestGlobal
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        // Helpers,
        //------------- Forms
        Forms 
    }

    const fetchAllQuotations = useFetchData.useFetchAllQuotations({...defaultFetchParams})
    const fetchAllInterests = useFetchData.useFetchAllInterests({...defaultFetchParams})
    const fetchInfoQuotation = useFetchData.useFetchInfoQuotation({...defaultFetchParams})
    
    const FetchData = {
        fetchAllQuotations,
        fetchAllInterests,
        fetchInfoQuotation,
    }

    const Actions = useActions({
        marvarApi, toggle, Helpers, user, 
        FetchData,
        globalStates,
        defaultData,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}